import {isSelectiveAiDomains} from 'common/HelperFunctions'
import {useEffect} from 'react'
import {useSelector} from 'react-redux'

import {ScrollComponent} from '_metronic/assets/ts/components'

import {SidebarAiCredits} from '../SidebarAiCredits'
import {SidebarBuyAiCredits} from '../SidebarBuyAiCredits'
import {SidebarMenuMain} from './SidebarMenuMain'

const SidebarMenu = () => {
  const generalSettings = useSelector((state: any) => state.mainReducer.generalSettings)
  const showInstituteFooter = isSelectiveAiDomains() && generalSettings?.tenantName

  useEffect(() => {
    // MasterInit bootstraps ScrollComponent once, 500ms after layout mount, and the wrapper
    // height is then only recomputed on window resize. On a cold first load the layout
    // (header height var, async settings) can settle after that one-shot init, leaving the
    // menu wrapper with a stale height and no scrollbar until refresh. Re-init for this
    // wrapper and recompute once things settle, and again if scroll dependencies toggle.
    ScrollComponent.reinitialization()
    const timer = setTimeout(() => {
      ScrollComponent.updateAll()
    }, 1000)
    return () => clearTimeout(timer)
  }, [showInstituteFooter])

  return (
    <div className='app-sidebar-menu overflow-hidden flex-column-fluid d-flex flex-column'>
      <div
        id='kt_app_sidebar_menu_wrapper'
        className='app-sidebar-wrapper hover-scroll-overlay-y my-5 flex-grow-1'
        data-kt-scroll='true'
        data-kt-scroll-activate='true'
        data-kt-scroll-height='auto'
        data-kt-scroll-dependencies={
          showInstituteFooter
            ? '#kt_app_sidebar_logo, #kt_app_sidebar_ai_credits, #kt_app_sidebar_institute_footer'
            : '#kt_app_sidebar_logo, #kt_app_sidebar_ai_credits'
        }
        data-kt-scroll-wrappers='#kt_app_sidebar_menu'
        data-kt-scroll-offset='5px'
        data-kt-scroll-save-state='true'
      >
        <div
          className='menu menu-column menu-rounded menu-sub-indention px-3'
          id='#kt_app_sidebar_menu'
          data-kt-menu='true'
          data-kt-menu-expand='false'
        >
          <SidebarMenuMain />
        </div>
        <SidebarBuyAiCredits />
      </div>
      <SidebarAiCredits />
      {showInstituteFooter && (
        <div
          id='kt_app_sidebar_institute_footer'
          className='flex-shrink-0 px-4 py-3 border-top border-gray-300 w-100 min-w-0 overflow-hidden'
        >
          <div className='d-flex justify-content-center w-100 min-w-0'>
            <div className='d-flex align-items-center gap-2 text-gray-600 min-w-0 mw-100'>
              <i
                className='fa-solid fa-school fs-3 flex-shrink-0'
                style={{position: 'relative', top: '-1px'}}
                aria-hidden
              />
              <span
                className='fw-semibold fs-3 app-sidebar-minimize-d-none text-break min-w-0'
                style={{overflowWrap: 'anywhere'}}
              >
                {generalSettings.tenantName}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export {SidebarMenu}
